import React, { useEffect, useState, useContext, Suspense, lazy, useMemo } from "react";
import { BrowserRouter } from "react-router-dom";


import Image from "./Components/Image";
import SideBar from "./Components/SideBar";
// import DetailsDrawer from "./Components/DetailsDrawer";
// import DetailsSubDrawer from './Components/DetailsSubDrawer';
// import DetailsModal from "./Components/DetailsModal";



// Pages
// import Register from "./Pages/Register";
// import Overview from "./Pages/Overview";
// import Users from "./Pages/Users";
// import Clients from "./Pages/Clients";
// import Email from './Pages/Email';
// import ClientsAdmin from "./Pages/ClientsAdmin";
// import Assessments from "./Pages/Assessments";
// import AssessmentsLeaders from "./Pages/AssessmentsLeaders";
// import AssessmentsMembers from "./Pages/AssessmentsMembers";
// import AssessmentFields from './Pages/AssessmentFields';
// import AssessmentAutomation from './Pages/AssessmentAutomation';





import AuthContext from './store/AuthContext.js';
import SidebarContext from './store/SidebarContext.js';
import Providers from './Components/Providers';
import AppRoutes from './Components/AppRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import AssessmentsQuestions from './Pages/AssessmentsQuestions';
// import AssessmentsSections from './Pages/AssessmentsSections';
// import AssessmentPage from './Pages/AssessmentPage';
// import AssessmentPageV2 from './Pages/AssessmentPageV2/AssessmentPageV2';
// import Engagement from './Pages/Engagement';
import LoadingSpinner from "./Components/UI/LoadingSpinner.jsx";
// import DataMining from './Pages/Datamining';
// import Pages from './Pages/Page';
// import AssesmentPage from './Pages/AssesmentPage.jsx';
// import SetupAssessment from './Pages/SetupAssessment.jsx';
// import AssessmentDashboardPage from './Pages/AssessmentDashboardPage';



const DetailsDrawer = lazy(() => import("./Components/DetailsDrawer"));
const DetailsSubDrawer = lazy(() => import("./Components/DetailsSubDrawer"));
const DetailsModal = lazy(() => import("./Components/DetailsModal"));




function App() {


  const authCtx = useContext(AuthContext);
  const sidebarCtx = useContext(SidebarContext);
  const [name, setName] = useState('');
  console.log(authCtx);


  const memoizedSideBar = useMemo(() => <SideBar />, []);


  const env = process.env.NODE_ENV;
  const API = process.env.REACT_APP_API_URI;


  useEffect(() => {
    if (env === "development" && API === "https://api.bleat.church") {
      console.log("%c\nYou are in development mode using the production API.\n", "color: red; font-size: 16px;");
    }
  }, [env, API]);


  async function memoryCheck() {
    if (!window.crossOriginIsolated) {
      console.warn('performance.measureUserAgentSpecificMemory() is only available in cross-origin-isolated pages');
    } else if (!performance.measureUserAgentSpecificMemory) {
      console.warn('performance.measureUserAgentSpecificMemory() is not available in this browser');
    } else {
      let result;
      try {
        result = await performance.measureUserAgentSpecificMemory();
      } catch (error) {
        if (error instanceof DOMException && error.name === 'SecurityError') {
          console.warn('The context is not secure.');
        } else {
          throw error;
        }
      }
      console.warn("memory check:", result);
    }
  }


  memoryCheck();



  return (
    <div className="App">


      <BrowserRouter>
        <Suspense fallback={<LoadingSpinner placement="overlay" size={32} />}>
          <Providers>
            {authCtx.isLoggedIn ? memoizedSideBar : null}
            <main className={sidebarCtx.isOpen ? "main main-closed" : "main"}>

              <AppRoutes name={name} setName={setName} />

            </main>


            <DetailsDrawer />
            <DetailsSubDrawer />
            <DetailsModal />
            <ToastContainer
              position="top-center"
              autoClose={4000}
              hideProgressBar
              newestOnTop
              closeOnClick={false}
              rtl={false}
              pauseOnFocusLoss
              draggable={false}
              pauseOnHover
              limit={3}
            />
          </Providers>
        </Suspense>
      </BrowserRouter>


    </div>
  );
}


export default App;
